var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.95,
    height: 29.964,
    viewBox: "0 0 14.95 29.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_646",
    "data-name": "Pfad 646",
    d: "M228.189,162.033l-8.5,9.133h-4.313a.783.783,0,0,0-.783.783v9.63a.783.783,0,0,0,.783.783h4.313l8.5,9.133a.783.783,0,0,0,1.356-.533V162.566A.783.783,0,0,0,228.189,162.033Z",
    transform: "translate(-214.595 -161.782)",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNo);
export default __webpack_public_path__ + "static/media/music-no.a0bc011eff63fa5b587bed6909f48a36.svg";
export { ForwardRef as ReactComponent };